import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { QueryParamsModel } from "../../_base/crud";
import { AssetClassHouseActions, AssetClassHouseActionTypes } from "../_actions/asset-class-house.actions";
import { AssetClassHouseModel } from "../_models/asset-class-house.model";

export interface AssetClassHouseState extends EntityState<AssetClassHouseModel> {
    actionLoading: boolean;
    listLoading: boolean;
    totalCount: number;
    totalTrashed: number;
    totalAdminTrashed: number;
    lastQuery: QueryParamsModel;
    previouslyCreatedACId: number;
    lastCreatedAssetClassHouseId: number;
    showInitWaitingMessage: boolean;
}
export const adapter: EntityAdapter<AssetClassHouseModel> = createEntityAdapter<AssetClassHouseModel>();
export const initialAssetClassHouseState: AssetClassHouseState = adapter.getInitialState({
    actionLoading: false,
    listLoading: false,
    totalCount: 0,
    totalTrashed: 0,
    totalAdminTrashed: 0,
    lastQuery: new QueryParamsModel({}),
    previouslyCreatedACId: undefined,
    lastCreatedAssetClassHouseId: undefined,
    showInitWaitingMessage: true
});

export function assetClassHouseReducer(
    state = initialAssetClassHouseState,
    action: AssetClassHouseActions
): AssetClassHouseState {
    switch (action.type) {
        case AssetClassHouseActionTypes.UpdatePreviouslyCreatedACId: {
            return {
                ...state,
                previouslyCreatedACId: state.lastCreatedAssetClassHouseId
            }
        }
        case AssetClassHouseActionTypes.AssetClassHousePageToggleLoading: {
            return {
                ...state, listLoading: action.payload.isLoading, lastCreatedAssetClassHouseId: undefined
            }
        }
        case AssetClassHouseActionTypes.AssetClassHouseActionToggleLoading: {
            return {
                ...state, actionLoading: action.payload.isLoading
            }
        }
        case AssetClassHouseActionTypes.AssetClassHouseOnServerCreated: {
            return state;
        }
        case AssetClassHouseActionTypes.AssetClassHouseCreated: {
            return adapter.addOne(
                action.payload.AssetClassHouse,
                {...state, 
                    previouslyCreatedACId: state.lastCreatedAssetClassHouseId,
                    lastCreatedAssetClassHouseId: action.payload.AssetClassHouse.id
                }
            )
        }
        case AssetClassHouseActionTypes.AssetClassHouseUpdated: {
            return adapter.addOne(
                action.payload.AssetClassHouse,
                {...state, lastCreatedAssetClassHouseId: action.payload.AssetClassHouse.id}
            )
        }
        case AssetClassHouseActionTypes.AssetClassHousePageLoaded: {
            return adapter.addMany(action.payload.AssetClassHouses, {
                ...initialAssetClassHouseState,
                totalCount: action.payload.totalCount,
                totalTrashed: action.payload.totalTrashed,
                totalAdminTrashed: action.payload.totalAdminTrashed,
                listLoading: false,
                lastQuery: action.payload.page,
                showInitWaitingMessage: false
            })
        }
        case AssetClassHouseActionTypes.AssetClassHouseDeleted: {
            return adapter.removeOne(action.payload.id, {
                ...state, totalTrashed: state.totalTrashed + 1
            })
        }
        case AssetClassHouseActionTypes.AssetClassHouseDeletedFromTrash: {
            return {
                ...state,
                totalTrashed: state.totalTrashed - 1,
                totalAdminTrashed: state.totalAdminTrashed + 1
            }
        }
        case AssetClassHouseActionTypes.AssetClassHouseDeletedFromAdminTrash:
            return {...state,
                totalAdminTrashed: state.totalAdminTrashed - 1
            };
        case AssetClassHouseActionTypes.AssetClassHouseOnServerRestored: {
            return state
        }
        case AssetClassHouseActionTypes.AssetClassHouseRestored: {
            return adapter.addOne(action.payload.ac, {
                ...state,
                lastCreatedAssetClassHouseId: action.payload.ac.id,
                totalTrashed: state.totalTrashed - 1
            })
        }
        case AssetClassHouseActionTypes.AssetClassHouseOnServerAdminRestored: {
            return state
        }
        case AssetClassHouseActionTypes.AssetClassHouseAdminRestored: {
            return adapter.addOne(action.payload.ac, {
                ...state,
                totalAdminTrashed: state.totalAdminTrashed - 1
            })
        }
        case AssetClassHouseActionTypes.AssetClassHouseTrashFlushed: {
            return {
                ...state, totalTrashed: 0, totalAdminTrashed: state.totalAdminTrashed + state.totalTrashed
            }
        }
        default: {
            return state;
        }
    }
}